<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-dropdown v-if="isAdmin" v-granted="'campaigns.create'" text="Create Campaign" variant="info" class="float-right">
              <b-dropdown-item :to="{ name: 'NewShopifyCampaign' }">Shopify Campaign</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'NewCampaign' }">Lead Campaign</b-dropdown-item>
            </b-dropdown>
            <!-- <router-link
              v-if="isAdmin"
              tag="button"
              class="btn btn-info float-right"
              :to="{ name: 'NewCampaign' }"
              v-granted="'campaigns.create'"
            >Create Campaign</router-link> -->
            <a
              v-else
              class="btn btn-info float-right"
              target="_blank"
              :href="surveyLink"
            >Start New Campaign</a>
            <h3 class="card-title pb-3">Campaigns</h3>
            <DataTable
              :columns="headers"
              fieldName="campaigns"
              :query="campaigns"
              placeholder="Search by Campaign name"
            >
              <span slot="type" slot-scope="props">
                <i class="mdi mdi-cart text-inverse" v-if="props.row.type === 'shopify'"></i>
              </span>
              <span slot="status" slot-scope="props" :class="[props.row.status ? 'text-success' : '', 'text-danger']">
                <i class="mdi mdi-checkbox-blank-circle"></i>
              </span>
              <span slot="campaignName" slot-scope="props">
                <router-link
                  :to="{ name: 'CampaignDetails', params: { id: props.row.id } }"
                >{{ props.row.campaignName }}</router-link>
              </span>
              <span slot="companyName" slot-scope="props">
                <router-link
                  :to="{ name: 'EditCompany', params: { id: props.row.companyId } }"
                >{{ props.row.companyName }}</router-link>
              </span>
              <span
                slot="created"
                slot-scope="props"
              >{{ props.row.created | moment("MMM Do YYYY") }}</span>
              <span slot="actions" slot-scope="props">
                <router-link
                  v-if="isAdmin && props.row.type === 'shopify'"
                  :to="{ name: 'EditShopifyCampaign', params: { id: props.row.id } }"
                >
                  <i class="mdi mdi-pencil text-inverse m-r-10"></i>
                </router-link>
                <router-link
                  v-if="isAdmin && props.row.type !== 'shopify'"
                  :to="{ name: 'EditCampaign', params: { id: props.row.id } }"
                >
                  <i class="mdi mdi-pencil text-inverse m-r-10"></i>
                </router-link>
                <router-link
                  v-if="isAdmin"
                  v-granted="'users.find'"
                  :to="{ 
                    name: 'AssignUsers', 
                    params: { campaignId: props.row.id },
                    query: {companyId: props.row.companyId}
                  }"
                >
                  <i class="mdi mdi-checkbox-marked-outline text-inverse"></i>
                </router-link>
              </span>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DataTable from '@/components/DataTable';
import CAMPAIGNS from '../../graphql/Campaigns/Campaigns.gql';

export default {
  name: 'Campaigns',
  components: {
    DataTable,
  },
  computed: {
    ...mapGetters(['getAuthUser', 'isUserAdmin', 'getCompany']),

    isAdmin() {
      return this.isUserAdmin;
    },

    campaigns() {
      return CAMPAIGNS;
    },

    surveyLink() {
      return `https://docs.google.com/forms/d/e/1FAIpQLSc2SoUSmtj80xFSCHfJ8qDYJaPCgDL0Gp3skfR4WmjkEpFoQw/viewform?usp=pp_url&entry.368622878=${encodeURIComponent(
        this.getCompany.companyName
      )}&entry.2039617643=${encodeURIComponent(
        this.getAuthUser.email
      )}&entry.1879569208=${encodeURIComponent(this.getAuthUser.phone)}`;
    },

    headers() {
      return [
        { field: 'id', title: 'ID' },
        { title: '', field: 'type' },
        { title: '', field: 'status' },{
          title: 'Campaign Name*',
          field: 'campaignName',
        },
        { title: 'Company', field: 'companyName' },
        { title: 'Email to*', field: 'dispatchTo' },
        { title: 'Created', field: 'created' },
        { title: 'Actions', field: 'actions', skipSorting: true },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Campaigns/Campaigns.vue